import React, { useState } from 'react';
import { Button } from '@components';
import { Card, Form, Row, Col, ButtonGroup } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
    messageError,
    messageToast,
    status200,
} from '../../utils/define';
import ReactSpinner from '../../components/reactSpinner/ReactSpinner';
import { ASSETGROUP_API } from '@app/utils/apiUrl';
import { useMutation } from 'react-query';
import { Post } from '@app/utils/httpProvider';
import HorizontalFieldsRow from '@app/components/common/HorizontalFieldsRow';
import Editor from '@app/components/editor/Editor';

const schema = yup.object().shape({
    assetGroupCode: yup.string().required(messageError.emptyMessage),
    assetGroupName: yup.string().required(messageError.emptyMessage),
    description: yup.string().nullable(),
});

const AssetGroupAdd = () => {
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);

    const addFunc = useMutation((value) =>
        Post(ASSETGROUP_API.ADD_ITEM, null, value, false)
    );

    const handleCreate = async (values) => {
        const model = values;

        addFunc.mutate(model, {
            onSuccess: (res) => {
                if (res.status !== status200) {
                    toast.error(messageToast.messageToastCreateError);
                } else {
                    setIsLoading(true);
                    toast.success(messageToast.messageToastCreateSuccess);
                    history.goBack();
                }
            },
            onError: (res) => {
                toast.error(
                    res.message || 'Đã có lỗi xảy ra, vui lòng thử lại !'
                );
            }
        });
    };

    return (
        <Card>
            <Card.Header as="h5">Thêm thông tin nhóm tài sản</Card.Header>
            <Card.Body>
                <Formik
                    validationSchema={schema}
                    onSubmit={(values) => handleCreate(values)}
                    initialValues={{
                        assetGroupCode: '',
                        assetGroupName: '',
                        description: ''
                    }}
                >
                    {({
                        handleSubmit,
                        handleChange,
                        values,
                        errors,
                        touched,
                        setFieldValue
                    }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <HorizontalFieldsRow
                                fields={[
                                    {
                                        label: 'Mã nhóm',
                                        name: 'assetGroupCode',
                                        value: values.assetGroupCode,
                                        onChange: handleChange,
                                        isInvalid: errors.assetGroupCode && touched.assetGroupCode,
                                        error: touched.assetGroupCode ? errors.assetGroupCode : null
                                    },
                                    {
                                        label: 'Tên nhóm',
                                        name: 'assetGroupName',
                                        value: values.assetGroupName,
                                        onChange: handleChange,
                                        isInvalid: errors.assetGroupName && touched.assetGroupName,
                                        error: touched.assetGroupName ? errors.assetGroupName : null
                                    }
                                ]}
                            />
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Mô tả
                                </Form.Label>
                                <Col sm="10">
                                    <Editor
                                        name="description"
                                        value={values.description}
                                        onChange={(value) => {
                                            setFieldValue(
                                                'description',
                                                value
                                            );
                                        }}
                                    />
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3">
                                <Col md={{ span: 10, offset: 2 }}>
                                    <ButtonGroup className="mb-2">
                                        <Button
                                            type="submit"
                                            theme="primary"
                                            disabled={isLoading}
                                        >
                                            Thêm
                                        </Button>
                                        &nbsp;&nbsp;&nbsp;
                                        <Button
                                            onClick={() => history.goBack()}
                                            theme="secondary"
                                        >
                                            Hủy
                                        </Button>
                                    </ButtonGroup>
                                </Col>
                            </Form.Group>
                        </Form>
                    )}
                </Formik>
                <ReactSpinner loadings={isLoading} />
            </Card.Body>
        </Card>
    );
};

export default AssetGroupAdd;
